import {
  Stack,
  Typography,
  Box,
  Divider,
  Button,
  Card,
  IconButton,
  CardContent,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useNavigate } from "react-router";
import tokens from "@/theme/tokens";
import ImageOne from "@/assets/images/LandingPage_Image1.svg?react";
import ImageTwo from "@/assets/images/LandingPage_Image2.svg?react";
import ImageThree from "@/assets/images/LandingPage_Image3.svg?react";
// react-slick is CJS; under Vite 8's interop the default import can resolve to
// the module namespace object, which React rejects with "Element type is
// invalid ... got: object". Same guard as Dashboard/Carousel.
import SliderImport from "react-slick";
import { slickArrowsSx } from "@/components/Dashboard/Carousel/styles";
import radii from "@/theme/radii";

const Slider = SliderImport.default || SliderImport;

const imageStyle = {
  maxHeight: "150px",
  width: "100%",
  marginBottom: tokens.space.px32,
};
const images = [
  {
    image: <ImageOne style={imageStyle} />,
    text: "textOne",
  },
  {
    image: <ImageTwo style={imageStyle} />,
    text: "textTwo",
  },
  {
    image: <ImageThree style={imageStyle} />,
    text: "textThree",
  },
];

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
};

const WelcomeRebelOverlay = ({ t, handleClose = () => { } }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = !useMediaQuery(theme.breakpoints.up("md"));
  const Images = () =>
    images.map((image) => (
      <Box key={image.text}>
        {image.image}
        <Typography align="center">{t(image.text)}</Typography>
      </Box>
    ));

  return (
    <Card
      sx={{
        background: (themeParam) => themeParam.palette.grey["200"],
        boxShadow: 2,
        borderRadius: { xs: radii.none, md: `${radii.xxl}px` },
        height: { xs: "unset", md: "max-content" },
        width: "100%",
      }}
      raised
    >
      <CardContent
        sx={{
          px: { xs: 3, md: 4 },
          py: { xs: 5, md: 2 },
          ":last-child": {
            pb: 4,
          },
        }}
      >
        <Stack direction="row" sx={{ alignItems: "flex-start", mb: 3 }}>
          <Box
            sx={{ width: "100%", pl: { xs: 0, md: 6 }, pr: { xs: 0, md: 1 } }}
          >
            <Typography variant="h1" align="center" sx={{ mb: 2 }}>
              Welcome Rebel!
            </Typography>
            <Typography variant="h3" align="center" sx={{ fontWeight: "bold" }}>
              {t("ReadyToTurnIdeasToReality")}
            </Typography>
          </Box>
          {!isMobile && (
            <IconButton onClick={handleClose}>
              <CloseRoundedIcon />
            </IconButton>
          )}
        </Stack>
        <Box sx={{ mt: 1 }}>
          {isMobile ? (
            <Card
              sx={{
                boxShadow: 2,
                borderRadius: `${radii.lg}px`,
              }}
              raised
            >
              <CardContent
                sx={{
                  ":last-child": {
                    pb: 5,
                  },
                  ...slickArrowsSx,
                }}
              >
                <Slider {...settings}>{Images()}</Slider>
              </CardContent>
            </Card>
          ) : (
            <Stack
              direction="row"
              sx={{
                gap: 8,
                justifyContent: "space-between"
              }}>
              <Images />
            </Stack>
          )}
        </Box>
        <Divider
          sx={{
            my: 5,
            borderWidth: "1px",
            borderColor: (themeParam) => themeParam.palette.grey["600"],
          }}
        />
        <Typography
          variant="h3"
          align="center"
          sx={{ fontWeight: "bold", mb: 4 }}
        >
          {t("InnovationCannotWait")}
        </Typography>
        <Stack sx={{ alignItems: "center" }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => {
              navigate("/project/create-project");
            }}
            sx={{ mb: { xs: 4, md: 2 } }}
          >
            {t("CreateFirstProject")}
          </Button>
          {isMobile && (
            <Button
              disableRipple
              sx={{ minHeight: 0, fontWeight: "normal" }}
              onClick={handleClose}
            >
              {t("SkipForNow")}
            </Button>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default WelcomeRebelOverlay;
